import { render, staticRenderFns } from "./dealHeaderChat.vue?vue&type=template&id=62f6b1aa&scoped=true&"
import script from "./dealHeaderChat.vue?vue&type=script&lang=js&"
export * from "./dealHeaderChat.vue?vue&type=script&lang=js&"
import style0 from "./dealHeaderChat.vue?vue&type=style&index=0&id=62f6b1aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f6b1aa",
  null
  
)

export default component.exports